'use client'

import React from 'react'
import { ButtonLink } from '@/components/Buttons/Buttons'
import { BrandWordmark } from '@/components/ui/BrandWordmark'
import { useEffect, useState } from 'react'
import { buildDiscoverUrlForCurrentHost, validateCurrentSitename } from '@/utilities/sitename'

export type DiscoverDriveButtonProps = {
  href?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

/**
 * DiscoverDriveButton – matches the header Discover button style
 */
export function DiscoverDriveButton({
  href = 'https://discoveryourdrive.com/',
  size = 'sm',
  className,
}: DiscoverDriveButtonProps) {
  const [computedHref, setComputedHref] = useState<string>(href)

  useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const { candidate, validation } = await validateCurrentSitename()
        const valid =
          validation.ok &&
          (validation.status === 'pending' ||
            validation.status === 'active' ||
            validation.status === 'approved')
        const target = buildDiscoverUrlForCurrentHost(valid ? (candidate as string) : null)
        if (mounted) setComputedHref(target)
      } catch {
        if (mounted) setComputedHref(href)
      }
    })()
    return () => {
      mounted = false
    }
  }, [href])

  return (
    <ButtonLink
      size={size}
      color="light"
      href={computedHref}
      className={`rounded-md bg-[#5A5A5A] hover:bg-[#6A6A6A] text-foreground border border-white/20 ${className || ''}`}
    >
      <span className="whitespace-nowrap inline-flex items-center">
        <span>Discover Your</span>
        <BrandWordmark fallbackHtml={null} className="ml-1 -translate-y-px" />
      </span>
    </ButtonLink>
  )
}
